import {
  FeatureFlagName,
  FeatureFlagNameMap,
  FeatureFlagsType,
} from '../featureFlags';

import { useFeatureFlag } from './useFeatureFlag';

export type UseFeatureFlagActiveOptions<
  T extends FeatureFlagName,
> = {
  readonly active?: (value: FeatureFlagsType[T]) => boolean;
};

const DEFAULT_ACTIVE_VARIATION = 'on';

const createActiveFn = (defaultActive: string) =>
  (value: FeatureFlagsType[keyof FeatureFlagsType]) =>
    value === defaultActive;

const defaultActiveFn = createActiveFn(DEFAULT_ACTIVE_VARIATION);

export const useFeatureFlagActive = <T extends FeatureFlagName>(
  getName: (flagNames: FeatureFlagNameMap) => T,
  {
    active = defaultActiveFn,
  }: UseFeatureFlagActiveOptions<T> = {},
): boolean => {
  const value = useFeatureFlag(getName);
  return active(value);
};
